// Temporary release switch. Restore to true when the new Start Guide is ready.
export const NEW_START_GUIDE_ENABLED = false;
